import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

const ErrorMessage = ({isAccessDenied}) =>
  isAccessDenied ? (
    <FormattedMessage
      id="Error__AccessDenied"
      defaultMessage={`You don't have card access`}
      description="Indicate that a card cannot be accessed"
    />
  ) : (
    <FormattedMessage
      id="Error__UnableToLoad"
      defaultMessage="Unable to load card"
      description="Indicate that a card was unable to load for an unknown reason"
    />
  );

ErrorMessage.propTypes = {
  isAccessDenied: PropTypes.bool,
};

export default ErrorMessage;
